import { useState } from "react";
import { Link } from "react-router-dom";
import InputMark from "./InputMark";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/input-performance-ai/id6758412527";

const NAV = [
  { label: "System", href: "/#system" },
  { label: "Spec", href: "/#spec" },
  { label: "Pricing", href: "/#pricing" },
  { label: "How it works", href: "/how" },
];

export function Wordmark({ size = 30 }: { size?: number }) {
  return (
    <Link to="/" className="flex items-center" aria-label="Input — home">
      <InputMark height={size} />
    </Link>
  );
}

export default function MarketingHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 border-b"
      style={{
        background: "rgba(255,255,255,0.88)",
        backdropFilter: "blur(12px)",
        borderColor: "var(--mk-line)",
      }}
    >
      <div className="max-w-screen-xl mx-auto px-5 h-[60px] flex items-center justify-between">
        <Wordmark />

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) =>
            item.href.startsWith("/#") ? (
              <a
                key={item.label}
                href={item.href}
                className="mk-label hover:text-[#0e1113] transition-colors"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.label}
                to={item.href}
                className="mk-label hover:text-[#0e1113] transition-colors"
              >
                {item.label}
              </Link>
            )
          )}
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mk-btn mk-btn-solid"
            style={{ padding: "10px 18px", fontSize: 12 }}
          >
            Get the app
          </a>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 -mr-2"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            viewBox="0 0 24 24"
          >
            {open ? (
              <path strokeLinecap="square" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="square" d="M3 7h18M3 12h18M3 17h18" />
            )}
          </svg>
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t px-5 py-6 flex flex-col gap-5"
          style={{ background: "var(--mk-carbon)", borderColor: "var(--mk-line)" }}
        >
          {NAV.map((item) =>
            item.href.startsWith("/#") ? (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="mk-label"
                style={{ fontSize: 13 }}
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.label}
                to={item.href}
                onClick={() => setOpen(false)}
                className="mk-label"
                style={{ fontSize: 13 }}
              >
                {item.label}
              </Link>
            )
          )}
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mk-btn mk-btn-solid"
          >
            Get the app
          </a>
        </div>
      )}
    </header>
  );
}
